import type { RouteType } from '~/types/router'

const Layout = () => import('@/layout/index.vue')

// 阅卷过程从“阅卷列表”进入，不作为独立菜单展示。
export default {
  name: 'examGradingProcessHidden',
  path: '/exam/grading-process/:taskId',
  component: Layout,
  isHidden: true,
  meta: {
    title: '阅卷评分',
    requireAuth: false,
  },
  children: [
    {
      name: 'examGradingProcess',
      path: '',
      component: () => import('./index.vue'),
      isHidden: true,
      meta: {
        title: '阅卷评分',
        requireAuth: false,
      },
    },
  ],
} as RouteType
